<template>
  <div class="sbd__outposts" role="group">
    <div v-for="(outposts,name) in displayOutpost" :key="name" :class="['sbd__outpost',{'active':isAccorExpanded(name)}]">
      <div @click="toggleAccorExpansion(name)" @keydown="handleKeydownOnAccordion($event, name)" class="sbd__outpost-header" tabindex="0" role="button" :aria-expanded="isAccorExpanded(name)">
        <div class="sbd__outpost-title-wrapper">
          <h4 class="sbd__outpost-title">{{name}}</h4>
          <span class="sbd__outpost-count">{{outposts.length}} {{ outposts.length > 1 ? 'Stores' : 'Store'}}</span>
        </div>
        <svg class="sbd__outpost-icon">
          <use xlink:href="#icon-next"></use>
        </svg>
      </div>  
      <div class="sbd__outpost-items" role="region" :aria-labelledby="'accordion-header-' + name">
        <div v-for="outpost in outposts" :key="outpost.name" class="sbd__outpost-item">
          <div v-if="isStudio(outpost.filters)" class="sbd__type-studio">
            <svg class="sbd__logo-icon">
              <use xlink:href="#icon-logo-tree"></use>
            </svg>
            <span>MOUNTAIN STUDIO</span>
          </div>
          <div v-else class="sbd__type-outpost">Authorized Retail Location</div>
          <div class="sbd__outpost-inner">
            <div class="sbd__outpost-item-wrapper">
              <div class="sbd__outpost-name">
                {{ outpost.name }}
                <span v-if="isSearch" class="sbd__outpost-distance">
                  ({{ outpost.distance }} {{outpost.distance_units}} away)
                </span>
              </div>
              <span class="sbd__outpost-copy">
                {{outpost.address_line_1}} {{outpost.city}}, {{outpost.state}} {{outpost.postal_code}}
              </span>
            </div>
            <div v-if="storeHours(outpost.custom_fields)" class="sbd__outpost-item-wrapper sbd__outpost-hours-wrapper">
              <span class="sbd__outpost-label">Store Hours</span>
              <span class="sbd__outpost-copy">{{ storeHours(outpost.custom_fields)}}</span>
            </div>
            <div class="sbd__outpost-item-wrapper">
              <span class="sbd__outpost-label">Contact</span>
              <span class="sbd__outpost-copy sbd__outpost-ph">{{ outpost.phone }}</span>
            </div>
            <div class="sbd__outpost-btn-wrapper">
              <a v-if="isStudio(outpost.filters)" :href="storeLink(outpost.custom_fields)" class="btn btn--secondary btn--medium">View Store</a>
              <a :href="directionLink(outpost.custom_fields)" target="_blank" class="btn btn--white btn--medium">Get Directions</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed, toRefs, ref, reactive, onMounted } from 'vue';

  const props = defineProps({
    outposts: {
      type: Array,
      required: true,
    },

    isSearch: {
      type: Boolean,
      default: false,
    }
  })

  const { outposts, isSearch } = toRefs(props)
  var expandedAccor = reactive([])

  onMounted(() => {
    if(isSearch.value){
      toggleAccorExpansion(Object.keys(displayOutpost.value)[0])
    }
  })

  const displayOutpost = computed(() => {
    const data = outposts.value.reduce((set, outpost) => {
      const property = outpost.state;
      const setItem = set[property] = set[property] || []
      setItem.push(outpost)
      return set
    }, {});
    
    return isSearch.value ? data : Object.fromEntries(Object.entries(data).sort())
  })

  const storeHours = (value) => {
    if(value.length){
      let data = value.filter(field => field.name === 'Store Hours')
      return data.length ? data[0].value : null
    }else{
      return null;
    }
  }

  const directionLink = (value) => {
    if(value.length){
      let data = value.filter(field => field.name === 'Direction Link')
      return data.length ? data[0].value : '/'
    }else{
      return '/';
    }
  }

  const storeLink = (value) => {
    if(value.length){
      let data = value.filter(field => field.name === 'View Store')
      return data.length ? data[0].value : '/'
    }else{
      return '/';
    }
  }

  const isStudio = (data) => {
    if(data.length && data[0].name.includes('Stio Mountain Studio')){
      return true;
    }else{
      return false;
    }
  }

  const isAccorExpanded = (key) =>  {
    return expandedAccor.indexOf(key) !== -1;
  }

  const toggleAccorExpansion = (key) => {
    if (isAccorExpanded(key)){
      expandedAccor.splice(expandedAccor.indexOf(key), 1);
    }else{
      expandedAccor.push(key);
    }       
  }

  const handleKeydownOnAccordion = (event, name) => {
    if (event.key === 'Enter' || event.key === ' ') {
      toggleAccorExpansion(name);
      event.preventDefault(); // Prevent scrolling with Space key
    }
  }
</script>